<template>
<div class="width100 padding15">

  <div class="darkblue bold font16">Controleer je gegevens: </div>
  <div class="mb-10 font-14">
    <div class="flexrow">

        <div class="flexbox">
          <div class="flexbox kolname">
            Voornaam
          </div>
          <div v-for="passenger in passengers">
            <div class="flexbox">
              {{passenger.voornaam}}
            </div>
          </div>
        </div>

        <div class="flexbox">
            <div class="flexbox kolname">
              Achternaam
            </div>
            <div v-for="passenger in passengers">
              <div class="flexbox">
                {{passenger.achternaam}}
              </div>
            </div>
        </div>

        <div class="flexbox">
          <div class="flexbox kolname">
            Geslacht
          </div>
          <div v-for="passenger in passengers">
            <div v-if="passenger.geslacht == 'Male'">
              <div class="flexbox">
                Man
              </div>
            </div>
            <div v-if="passenger.geslacht == 'Female'">
              <div class="flexbox">
                Vrouw
              </div>
            </div>
          </div>
        </div>

        <div class="flexbox">
          <div class="flexbox kolname">
            Geboortedatum
          </div>
          <div v-for="passenger in passengers">
            <div class="flexbox">
              {{
                moment(passenger.geboortedatum).format('L')
              }}
            </div>
          </div>
        </div>

        <div class="flexbox">
          <div class="flexbox kolname">
            Nationaliteit
          </div>
          <div v-for="passenger in passengers">
            <div v-for="(nationality, index) in nationalities.collection">
              <div v-if="nationality.value == passenger.nationaliteit">
                <div class="flexbox">
                  {{nationality.text}}
                  </div>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="width90 margintop10 bordertopgrey1 darkblue"></div>

    <div class="flexrow">
      <div class="flexbox">
        <div class="flexbox kolname ">
          Adres
        </div>
        <div class="flexbox">
          {{ passengers[0].straat }} {{ passengers[0].huisnummer }}
        </div>
        <div class="flexbox">
          {{ passengers[0].postcode }} {{ passengers[0].plaatsnaam }}
        </div>
      </div>

      <div class="flexbox">
        <div class="flexbox kolname ">
          Contactgegevens
        </div>
        <div class="flexbox">
          {{ passengers[0].telefoonnummer }}
        </div>
        <div class="flexbox">
          {{ passengers[0].emailadres }}
        </div>
      </div>
    </div>

  </div>
  <b v-on:click="previousStep()" style="cursor: pointer">
    Wijzig je gegevens</b>
</div>


</template>

<script>
export default {
    name: 'Boekingsoverzicht',
    props: {
        passengers: Array,
        nationalities: Object,
    },
    computed: {
    },
    methods: {
      previousStep() {
        this.$emit('toPreviousStep');
      },
    },
}
</script>

<style lang="scss" scoped>

.flexrow {
 display: flex;
  width:100%;
  flex-wrap: wrap;
  .flexbox {

    width:20%;
    .flexbox {
      width:100%;
    }
    padding-right: 10px;
    box-sizing: border-box;
    display: flex;
    flex-flow:column;
    .nextline {
      .select-drop {
        margin-right:10px;
      }
    }
  }
}

.mb-10 {
  margin-bottom: 10px;
}

.font-14 {
  font-size: 14px;
}

.kolname {
  font-size: 14px;
  font-weight: bold;
  margin-top: 10px;
}

.blueheader {
  color: #2078b3;
  font-size:22px;
}

.flex3 .flexbox {
  width: calc(100% / 3);
}


@media screen and (max-width: 1024px) {
  .flexrow
  {
    .flexbox {
      width: calc(100% / 3);
      .flexbox {
        width: 100% !important;
      }
    }
    .flexsize2 {
      .flexbox {
        width: calc(100% / 2) !important;
        .flexbox {
          width: 100% !important;
        }
      }
    }
    flex-flow: row wrap;
    margin-top:5px;
  }
}
@media screen and (max-width: 1024px) {
    .width20,
    .width40 {
        width: 100%;
    }
    .nextline {
        width: 100% !important;
        float: left;
        padding: 0;
    }
    .nextline .width20 {
        width: calc((100% / 3) - 10px) !important;
        margin: 0 5px;
    }
    .nextline:first-child {
        margin-left: 0;
    }
    .nextline:nth-last-child {
        margin-right: 0;
    }
    .select-drop select {
        width: 100%;
        margin-top: 5px;
        margin-bottom: 5px;
    }
}
@media screen and (max-width: 580px) {
  .flexrow {
    .flexbox {
      width: 50%;
    }
  }
}
@media  screen  and (max-width: 400px){
    .flexrow {
      .flexbox {
        width: 100%;
      }
      flex-flow: column !important;
    }
}



label {
  cursor:pointer;
}
.floatleft2 {
  float: left;
}

.idealsmall-img {
  background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
  background-position: -289px -258px;
  display: block;
  width: 22px;
  height: 28px;
}

.paypalsmall-img {
  background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
  background-position: -314px -258px;
  display: block;
  width: 60px;
  height: 28px;
}

.mrcashsmall-img {
  background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
  background-position: -432px -259px;
  display: block;
  width: 34px;
  height: 32px;
}

.visasmall-img {
  background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
  background-position: -376px -260px;
  display: block;
  width: 28px;
  height: 28px;
}

.mastersmall-img {
  background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
  background-position: -404px -260px;
  display: block;
  width: 28px;
  height: 28px;
}

.amexsmall-img {
  background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
  background-position: -506px -258px;
  display: block;
  width: 21px;
  height: 21px;
}
</style>
